import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcCancel24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 2a9.99 9.99 0 0 1 10 10 9.99 9.99 0 0 1 -10 10 9.99 9.99 0 0 1 -10-10 9.99 9.99 0 0 1 10-10zm0 2c-4.406 0-8 3.594-8 8s3.594 8 8 8 8-3.594 8-8-3.594-8-8-8zm-4.5 11.5c0-.219.094-.5.281-.688l2.813-2.812-2.814-2.781a1.166 1.166 0 0 1 -.28-.719c0-.563.469-1 1-1 .219 0 .5.094.719.281l2.781 2.813 2.781-2.781c.219-.22.5-.313.781-.313.47 0 .938.313.938 1 0 .25-.125.531-.313.719l-2.779 2.781 2.812 2.781c.187.188.281.5.281.719 0 .563-.469 1-1 1-.219 0-.5-.094-.719-.281l-2.782-2.813-2.813 2.814c-.156.187-.437.281-.687.281-.563 0-1-.469-1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcCancel24;
